export const GET_QR_CODES = 'Get_QR_Codes';